import { useEffect, useState } from 'react';

/**
 * Slim 2px gold scroll-progress rail anchored to the top of the viewport.
 * No external libs — uses scroll event + CSS transform: scaleX for 60fps smoothness.
 * Respects prefers-reduced-motion via the global CSS rule.
 */
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    let ticking = false;
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? Math.min(1, h.scrollTop / max) : 0);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <div
      className="scroll-progress-rail"
      style={{ transform: `scaleX(${pct})`, opacity: pct > 0.005 ? 1 : 0 }}
      aria-hidden="true"
    />
  );
}
